import * as Sentry from "@sentry/react";
import type { Breadcrumb } from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

// Tailwind/shadcn elements carry huge utility-class lists, which Sentry's
// default breadcrumb selector dumps in full (e.g. "input.file:text-foreground
// .placeholder:text-muted-foreground...[name=\"email\"]"). Strip the class
// chain and keep just the tag + meaningful attributes (id/name/type/aria-*),
// e.g. "input[type=\"text\"][name=\"email\"]".
function simplifySelector(selector: string): string {
  return selector.replace(/^(\w+(?:#[^.[\s]+)?)(\.[^[\s]+)*/, "$1");
}

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: __SENTRY_RELEASE__,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),  //to record session
    ],
    tracesSampleRate: import.meta.env.MODE === "production" ? 0.2 : 1.0,
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/dev\.api\.anthro\.care\/api/,
    ],
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    beforeBreadcrumb(breadcrumb: Breadcrumb) {
      if (
        (breadcrumb.category === "ui.click" ||
          breadcrumb.category === "ui.input") &&
        typeof breadcrumb.message === "string"
      ) {
        breadcrumb.message = simplifySelector(breadcrumb.message);
      }
      return breadcrumb;
    },
  });
} else {
  console.warn("VITE_SENTRY_DSN not set – Sentry is disabled.");
}
